import { v4 as uuidv4 } from 'uuid'
import {eventListenerService, postMessageService} from '@/modules/common/services'

const OUT_FRONTAGE_EVENT_NAME = 'vue-message'
const INCOMING_FRONTAGE_EVENT_NAME = 'on-frontage-message'

export const frontageApiService = {
  send(eventName, data = {}) {
    postMessageService.post(OUT_FRONTAGE_EVENT_NAME, {eventName, data})
  },

  get(eventName, data = {}) {
    return new Promise((resolve, reject) => {
      const uid = `event-${eventName}-${uuidv4()}`
      const cb = (data) => {
        resolve(data)
        eventListenerService.removeListener(uid, cb)
      }
      eventListenerService.addListener(uid, cb)

      postMessageService.post(OUT_FRONTAGE_EVENT_NAME, {eventName, data, eventUid: uid})
    })
  },

  navigateTo(to, params = {}, options = {}) {
    this.send('navigateTo', {to, params, options})
  },

  historyBack() {
    this.send('historyBack')
  },

  openExternal(url, params) {
    const defaultParams = {target: '_system'};
    const mergeParams = {...defaultParams, ...params};
    this.send('openExternal', {url, params: mergeParams});
  },

  listen(eventName, cb) {
    return eventListenerService.addListener(eventName, cb)
  },

  remove(eventName, cb) {
    return eventListenerService.removeListener(eventName, cb)
  }
}


const FrontageApiPlugin = {
  install(Vue, options) {
    Vue.prototype.$frontageApi = frontageApiService

    eventListenerService.addListener(INCOMING_FRONTAGE_EVENT_NAME,
      ({event, data}) => eventListenerService.emit(event, data))
  }
};

export default FrontageApiPlugin;
